import type { CSSProperties } from "react";
import type { PrismancyIconId } from "../../icons/icon-font/generated/prismancy-icons";

export type IconFontSize = 12 | 16 | 24 | 32;

type IconFontProps = {
  name: PrismancyIconId;
  size?: IconFontSize;
  id?: string;
  className?: string;
  style?: CSSProperties;
  strokeWidth?: number | string;
  title?: string;
  "aria-hidden"?: boolean;
};

const iconSources = import.meta.glob("../../icons/icon-font/svg/*.svg", {
  eager: true,
  import: "default",
  query: "?raw",
}) as Record<string, string>;

const IconFont = ({
  name,
  size = 24,
  id,
  className = "",
  strokeWidth = 1.25,
  title,
  style,
  "aria-hidden": ariaHidden,
}: IconFontProps) => {
  const source = iconSources[`../../icons/icon-font/svg/${name}.svg`];
  const accessibilityProps = title
    ? { role: "img", "aria-label": title }
    : { "aria-hidden": ariaHidden ?? true };

  if (!source) {
    return null;
  }

  return (
    <span
      className={`pi pi-${size} ${className}`.trim()}
      id={id}
      data-icon={name}
      dangerouslySetInnerHTML={{ __html: source }}
      style={{
        color: style?.color,
        "--pi-stroke-width": strokeWidth,
        ...style,
      } as CSSProperties}
      title={title}
      {...accessibilityProps}
    />
  );
};

export default IconFont;
